module.exports = __webpack_public_path__ + "static/media/punkNecklace.b7ce3b98.jpg";